import globalConfig from '@utiles/officialStore/globalConfig';

const gameInfoConfig = {
  390: {
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'mudepwagift'
    },
    // 添加到桌面背景和按钮
    pwaInstallPopupBg: require('@assets/image/officialTopup/muglo/pwa-install-popup-bg.png'),
    pwaInstallPopupBtn: require('@assets/image/officialTopup/muglo/pwa-install-popup-btn.png'),
    pwaInstalledAward: require('@assets/image/officialTopup/muglo/pwa-installed-award.png')
  }
};

export const ZTMSLG_GAMES = [191, 225, 227, 284];
export const DTMSLG_GAMES = [285, 354, 355];

export const DOMAIN_MAP = {
  191: ['37games.com', 'pnsofficial.com', 'blancozone.com'], // 主版本游戏域名：需要包含分版本游戏域名
  225: ['blancozone.com'], // 分版本游戏域名
  227: ['blancozone.com'], // 分版本游戏域名
  284: ['37games.com', 'pnsofficial.com'], // 分版本游戏域名

  285: ['37games.com'], // 主版本游戏域名：需要包含分版本游戏域名
  354: ['blancozone.com'], // 分版本游戏域名
  355: [] // 分版本游戏域名，看到支付页管理后台没有配置，先空着
};

export const mergeGameDomainList = domainList => {
  const set = new Set(domainList);
  const gameId =
    globalConfig.getHrefParam('gameId') ||
    globalConfig.getHrefParam('gameID') ||
    globalConfig.getHrefParam('game_id') ||
    '';
  if (DOMAIN_MAP[Number(gameId)]) {
    DOMAIN_MAP[Number(gameId)].forEach(domain => {
      set.add(domain);
    });
  }
  return Array.from(set);
};

export default gameInfoConfig;
